
class FileMetaData {
    constructor(file) {
        this.file = file;
        this.name = file?.name || '';
        this.size = file?.size || 0;
        this.type = file?.type || '';
    }

    // Get file name without extension
    get nameWithoutExtension() {
        return this.name.replace(/\.[^/.]+$/, '');
    }

    // Get file extension
    get extension() {
        return this.name.split('.').pop() || '';
    }

    // Get file size in MB
    get sizeInMB() {
        return (this.size / (1024 * 1024)).toFixed(2);
    }

    // Check if file is an image
    get isImage() {
        return this.type.startsWith('image/');
    }

    // Check if file is a document
    get isDocument() {
        const docTypes = ['pdf', 'doc', 'docx', 'txt', 'rtf'];
        return docTypes.includes(this.extension.toLowerCase());
    }

    get isVideo() {
        return this.type.startsWith('video/');
    }

    get isPdf() {
        return this.extension.toLowerCase() === 'pdf';
    }

    get isPowerPoint() {
        const pptTypes = ['ppt', 'pptx', 'pot', 'potx', 'odp'];
        return pptTypes.includes(this.extension.toLowerCase());
    }
}

export default FileMetaData;
